import PersonForm from './PersonForm'

export default PersonForm
